import { useEffect, useState } from "react";

const useHashArray = (
  arr,
  uniqueFieldName,
  isBool = false,
  isNested = false,
  subArrFieldName
) => {
  const [hashTable, setHashTable] = useState(null);
  useEffect(() => {
    const newHashTable = {};
    const createHashTable = (val) => {
      if (isBool) {
        newHashTable[val?.[uniqueFieldName]] = true;
      } else {
        newHashTable[val?.[uniqueFieldName]] = val;
      }
      if (isNested && val?.[subArrFieldName]?.length > 0) {
        val?.[subArrFieldName]?.forEach((val) => {
          createHashTable(val);
        });
      }
    };
    arr?.forEach((val) => {
      createHashTable(val);
    });
    setHashTable(newHashTable);
  }, [arr, uniqueFieldName, isBool, isNested, subArrFieldName]);

  return { hashTable };
};

export default useHashArray;
